import React from "react";
import "./style.css";
import logo from "./logo_b.png"; 
import { Link } from "react-router-dom";

// This file exports both the List and ListItem components


 
  
export function FinalList(props) {
	const menu_items = props.menus.map( (item, index) => (
		<li className="nav-item" data-name={item.name} key={item.name} onClick={props.menuClicked}>{item.name}</li>
	));
  return (
	    
    <div className="container-fluid">     
   <img className="logo" src={logo} alt="Logo" />
   <ul className="nav2 page_nav">{menu_items}</ul>
   <ul className="container-fluid list-group2">{props.children}</ul>
    </div>
  );
}

export function FinalListItem({ children }) {
  return <li className="list-group-item3">{children}</li>;
}


